import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';

export function LandingPage() {
    return (
        <div className="min-h-screen bg-background flex flex-col">
            {/* Navigation */}
            <nav className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex justify-between items-center">
                <div className="flex items-center gap-2">
                    <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary to-secondary">
                        Intpcat
                    </span>
                </div>
                <div className="flex items-center gap-4">
                    <Link to="/login">
                        <Button variant="ghost" className="font-semibold text-gray-600 hover:text-primary">
                            Log In
                        </Button>
                    </Link>
                    <Link to="/login">
                        <Button variant="primary" className="shadow-lg shadow-primary/20">
                            Get Started
                        </Button>
                    </Link>
                </div>
            </nav>

            {/* Hero Section */}
            <main className="flex-1 flex flex-col items-center justify-center text-center px-4 sm:px-6 lg:px-8 -mt-20">
                <div className="max-w-4xl mx-auto space-y-8 animate-fade-in-up">
                    <h1 className="text-5xl sm:text-7xl font-extrabold tracking-tight">
                        Master Your Habits <br />
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-primary via-purple-500 to-secondary animate-gradient-x">
                            Gamify Your Life
                        </span>
                    </h1>

                    <p className="text-xl sm:text-2xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
                        Transform your daily routines into epic quests. visual progress tracking,
                        AI-powered insights, and a journey that evolves with you.
                    </p>

                    <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
                        <Link to="/login" className="w-full sm:w-auto">
                            <Button size="lg" className="w-full sm:w-auto min-w-[200px] text-lg h-14 shadow-xl shadow-primary/25 hover:scale-105 transition-transform duration-200">
                                Start Your Journey
                            </Button>
                        </Link>
                        <Link to="/login" className="w-full sm:w-auto">
                            <Button variant="ghost" size="lg" className="w-full sm:w-auto min-w-[200px] text-lg h-14 hover:bg-gray-50 border-2 border-gray-200">
                                View Demo
                            </Button>
                        </Link>
                    </div>
                </div>

                {/* Feature Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mt-24 px-4">
                    <FeatureCard
                        icon="⚔️"
                        title="Daily Quests"
                        description="Turn mundane tasks into rewarding battles. Complete quests to level up your character."
                    />
                    <FeatureCard
                        icon="🌲"
                        title="Forest Visualizer"
                        description="Watch your consistency grow into a vibrant forest. A visual testament to your journey."
                    />
                    <FeatureCard
                        icon="🧠"
                        title="AI Insights"
                        description="Get personalized feedback and pattern analysis from your AI companion."
                    />
                </div>
            </main>

            {/* Footer */}
            <footer className="py-8 text-center text-gray-500 text-sm">
                <p>© {new Date().getFullYear()} Intpcat. All rights reserved.</p>
            </footer>
        </div>
    );
}

function FeatureCard({ icon, title, description }: { icon: string; title: string; description: string }) {
    return (
        <div className="bg-white/50 backdrop-blur-sm border border-white/20 p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
            <div className="text-4xl mb-4 bg-gray-50 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto">
                {icon}
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">{title}</h3>
            <p className="text-gray-600">{description}</p>
        </div>
    );
}
